import React from 'react';
import { Text, StyleProp, TextStyle, TouchableOpacity, ViewStyle, Pressable } from 'react-native';

interface IText2Invisible
{
style           : StyleProp<TextStyle>;
pressable_style : StyleProp<ViewStyle>;

getText: () => string;

bindEvent : (onEvent    : (() => void), 
             bSubscribe : boolean) => void;

onPress? : () => void;             
}

/*   ====================================================================   */

export default class Text2Invisible extends React.Component<IText2Invisible>
 {
   UpdateData()
   {
    let sNewText = this.props.getText();

    if (this.state.text != sNewText)
        {
        this.setState({text: sNewText});
        }
   }

   /*   ------------------------------------------------------------------   */

    constructor(props)
    {
    super(props);

    this.state      = {text:this.props.getText()};

    this.UpdateData = this.UpdateData.bind(this);
    }

    /*   ------------------------------------------------------------------   */

    componentDidMount() 
    {
    this.props.bindEvent(this.UpdateData, true);
    }

    /*   ------------------------------------------------------------------   */

    componentWillUnmount() 
    {
    this.props.bindEvent(this.UpdateData, false);
    }

    /*   ------------------------------------------------------------------   */
    
    
   state = {
      text: " "
   }

   /*   ------------------------------------------------------------------   */

   render() 
     {
      if (this.state.text == " ")
         return(null);
      return (
         // <Pressable style={{backgroundColor:'yellow'}}>
         <TouchableOpacity style={this.props.pressable_style} onPress={this.props.onPress} 
           //hitSlop={{ bottom: 40, left: 20, right: 40, top: 20 }}
           >
         <Text onPress={this.props.onPress} style={this.props.style}>{this.state.text}</Text>
        </TouchableOpacity>
      //   </Pressable>
      );
   }
}